import {useFilterByPlatformAdmin} from '@/biz/platformAdmin.jsx'

export default () => {
    const filterByPlatformAdmin = useFilterByPlatformAdmin()

    return filterByPlatformAdmin({
        title: '平台管理',

        children: [
            {
                title: '系统配置',
                to: ['/SmSet'],
            },

            {
                title: '智能运维',
                to: ['/AiOperation'],
            },

            // {
            //     title: '需求分析智能体',
            //     to: ['/RatopaiAgent'],
            // },
        ]
    })
}
